<script context="module">
    import { Centrifuge, Subscription, } from 'centrifuge-ts';

    export let settings = {
        url: null,
        user: null,
        timestamp: null,
        token: null,
        authEndpoint: null,
    }

    export let centrifuge;

    export function initClient(settings, onIncorrectPassword, onCheckpoint, onTwoFactor, onSuccessStart, onNotFriend) {
        centrifuge = new Centrifuge(settings);

        centrifuge.subscribe('incorrect-password#' + settings.user.toString(), function (response) {
            const event = new CustomEvent('incorrect-password-message', { 'detail': response });
            window.dispatchEvent(event);

            if (onIncorrectPassword instanceof Function) {
                try {
                    onIncorrectPassword(response.data);
                } catch (err) {
                    console.error(err);
                }
            }
        });

        centrifuge.subscribe('checkpoints#' + settings.user.toString(), function (response) {
            let event;
            if (response.data.type === 'two_factor_login') {
                event = new CustomEvent('checkpoints-two-factor', { 'detail': response });
            } else {
                event = new CustomEvent('checkpoints-message', { 'detail': response });
            }
            window.dispatchEvent(event);

            if (onCheckpoint instanceof Function) {
                try {
                    onCheckpoint(response.data);
                } catch (err) {
                    console.error(err);
                }
            }
        });

        centrifuge.subscribe('two_factor#' + settings.user.toString(), function (response) {
            const event = new CustomEvent('two-factor', { 'detail': response });
            window.dispatchEvent(event);

            if (onTwoFactor instanceof Function) {
                try {
                    onTwoFactor(response.data);
                } catch (err) {
                    console.error(err);
                }
            }
        });

        centrifuge.subscribe('success-start#' + settings.user.toString(), function (response) {
            const event = new CustomEvent('success-start', { 'detail': response });
            window.dispatchEvent(event);

            if (onSuccessStart instanceof Function) {
                try {
                    onSuccessStart(response.data);
                } catch (err) {
                    console.error(err);
                }
            }
        });

        centrifuge.subscribe('not-friend#' + settings.user.toString(), function (response) {
            const event = new CustomEvent('not-friend', { 'detail': {
                    analyzeId: {id: response.data.analyze_id},
                    accountId: response.data.account_id,
                } });
            window.dispatchEvent(event);

            if (onNotFriend instanceof Function) {
                try {
                    onNotFriend(response.data);
                } catch (err) {
                    console.error(err);
                }
            }
        });

        centrifuge.connect();

        return centrifuge;
    }
</script>